import {
    Phone,
    MessageCircle,
    Mail,
    User
} from "lucide-react";

import Avatar from "../shared/Avatar";
import Card from "../shared/Card";
import Button from "../shared/Button";

import { openWhatsapp } from "../../utils/whatsapp";

export default function ProfileCard({

    lead,onEdit

}){

    if(!lead){

        return null;

    }

    return(

        <Card className="crm-profile-card">

            <div className="crm-profile-header">

                <Avatar

                    src={lead.photo}

                    name={`${lead.first_name || ""} ${lead.last_name || ""}`}

                    size={72}

                />

                <div className="crm-profile-info">

                    <h2>

                        {lead.first_name} {lead.last_name}

                    </h2>

                    <p>

                        <User size={15}/>

                        Mother : {lead.mother_name || "-"}

                    </p>

                    <p>

                        <Phone size={15}/>

                        {lead.mobile}

                    </p>

                    <p>

                        <Mail size={15}/>

                        {lead.email || "-"}

                    </p>

                </div>

            </div>

            <div className="crm-profile-actions">

                <Button

                    variant="success"

                    icon={<Phone size={16}/>}

                    onClick={()=>

                        window.open(

                            `tel:${lead.mobile}`

                        )

                    }

                >

                    Call

                </Button>

                <Button

                    variant="primary"

                    icon={<MessageCircle size={16}/>}

                    onClick={()=>

                        openWhatsapp(

                            lead.mobile,

                            `Hello ${lead.first_name}, regarding your loan application.`

                        )

                    }

                >

                    WhatsApp

                </Button>
<Button

variant="secondary"

onClick={onEdit}

>

Edit

</Button>
            </div>
<style>{`.crm-profile-card{

    display:flex;

    flex-direction:column;

    gap:20px;

}

.crm-profile-header{

    display:flex;

    gap:18px;

    align-items:center;

}

.crm-profile-info{

    flex:1;

}

.crm-profile-info h2{

    margin:0;

    font-size:22px;

    font-weight:600;

}

.crm-profile-info p{

    display:flex;

    align-items:center;

    gap:8px;

    margin-top:8px;

    color:#666;

    font-size:14px;

}

.crm-profile-actions{

    display:flex;

    gap:12px;

}`}</style>
        </Card>

    );

}